import React, { useEffect } from 'react';
import * as api from './FilesApi';
import * as notifications from 'lib/notifications';
import { AttachedFileDto } from 'models/index';
import Dropzone from 'react-dropzone';

interface IUploadFileZoneProps {
    selectedFolder?: AttachedFileDto;
    onFilesUploaded?: () => void;
}
export function UploadFileZone(props: IUploadFileZoneProps) {
    const [uploadFile, setUploadFile] = React.useState<File[]>();
    useEffect(() => {
        // Update the document title using the browser API
        //console.log("useEffect called, uploadedFile changed!");
        if (uploadFile != null) {
            const request = { parentId: props.selectedFolder?.id };
            console.log("uploadFile", request);
            api.attachedFilesPost(request, uploadFile).then(data => {
                //console.log("supplierInvoiceAttachesFilesPost() got data", data);
                // Seems like it mostly never returns anything from this function. Why?
                // if (data && data.value) {
                //   const newfiles = [...files, data.value]
                //   setFiles(newfiles);
                // }
                notifications.dispatch("Filen skapades", 5);
                // updateNrOfAttachedFiles(data);
                setUploadFile(null);
                if (props.onFilesUploaded) {
                    props.onFilesUploaded();
                }
            }).catch((reason) => {
                //console.log("supplierInvoiceAttachedFilesPost catch", reason);
                notifications.dispatchFromError("Fel vid uppaddning av fil", reason, 60);
            });
        }
    }, [uploadFile]);


    return (<Dropzone onDrop={acceptedFiles => {
        //console.log("acceptedFiles", acceptedFiles);
        setUploadFile(acceptedFiles);
    }}>
        {({ getRootProps, getInputProps }) => (
            <section className="dropzoneContainer">
                <div {...getRootProps({ className: 'dropzone' })}>
                    <input {...getInputProps()} />
                    <p>Dra filen hit eller klicka för att välja filer...</p>
                </div>
            </section>
        )}
    </Dropzone>

    );
}
